var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart__running-advanced"},[_c('ChartRunningGroupDetailled',_vm._b({},'ChartRunningGroupDetailled',{ aggregates: _vm.aggregates, segments: _vm.segments, displayMetrics: _vm.displayMetrics },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }